var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.04687 1.5752H13.9469C14.7719 1.5752 15.4469 2.2502 15.4469 3.0752V4.7252C15.4469 5.3252 15.0719 6.0752 14.6969 6.4502L11.4719 9.30019C11.0219 9.67519 10.7219 10.4252 10.7219 11.0252V14.2502C10.7219 14.7002 10.4219 15.3002 10.0469 15.5252L8.99687 16.2002C8.02187 16.8002 6.67187 16.1252 6.67187 14.9252V10.9502C6.67187 10.4252 6.37187 9.7502 6.07187 9.3752L3.22188 6.3752C2.84688 6.0002 2.54688 5.3252 2.54688 4.8752V3.1502C2.54688 2.2502 3.22187 1.5752 4.04687 1.5752Z",
    stroke: "#949699",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.1975 1.5752L4.5 7.5002",
    stroke: "#949699",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.b3245bb1a13c4819977cbe15f28b9b9d.svg";
export { ForwardRef as ReactComponent };